import axios, { InternalAxiosRequestConfig } from 'axios';
import { Middleware, MiddlewareAPI } from 'redux';
import { Dispatch, RootState } from 'shared/state';

// Utility function to extract siteId from the state
// remove state.site?.initialData.siteId once all existing sites are saved and published
export const extractSiteId = (state: RootState): number | undefined => {
  return state.site?.initialData.siteId || state.sites?.data?.[0]?.siteId;
};

const instance = axios.create({
  baseURL: '/api/link/',
});

const bindInterceptors = (
  getState: MiddlewareAPI<Dispatch, RootState>['getState']
) => {
  instance.interceptors.request.use(config => {
    const state = getState();
    const token = state.oidc?.user?.access_token;
    const siteId = extractSiteId(state);

    if (token) {
      config.headers =
        config.headers || ({} as InternalAxiosRequestConfig['headers']);
      config.headers.set('Authorization', `Bearer ${token}`);
    }
    if (siteId) {
      config.headers =
        config.headers || ({} as InternalAxiosRequestConfig['headers']);
      config.headers.set('siteId', siteId.toString());
    }
    config.headers =
      config.headers || ({} as InternalAxiosRequestConfig['headers']);
    config.headers.set('isDuplo', 'false');

    return config;
  });
};

const middleware: Middleware<{}, RootState> = store => {
  bindInterceptors(store.getState);
  return next => action => next(action);
};

export { middleware };
export default instance;
